export default __webpack_public_path__ + "static/media/up.b3c409e6.svg";